module.exports = __webpack_public_path__ + "media/brian.fb900f6d.mp3";